/**
 * Web routes → the Android screen names (contracts/web-routes.md), so admin
 * statistics compare "screens" across both clients (WEB-028). First match wins,
 * so specific paths come before patterns.
 */
const ROUTES: [RegExp, string][] = [
  [/^\/$/, 'Home'],
  [/^\/welcome$/, 'Onboarding'],
  [/^\/info\/[^/]+$/, 'Info'],
  [/^\/signup\/pledge$/, 'Pledge'],
  [/^\/signup$/, 'SignUp'],
  [/^\/login$/, 'Login'],
  [/^\/forgot-password$/, 'ForgotPassword'],
  [/^\/verify-phone$/, 'PhoneVerification'],
  [/^\/browse$/, 'Browse'],
  [/^\/posts\/new$/, 'CreatePost'],
  [/^\/posts\/[^/]+\/edit$/, 'CreatePost'],
  [/^\/posts\/[^/]+\/matches$/, 'Matching'],
  [/^\/posts\/[^/]+$/, 'PostDetail'],
  [/^\/commitments\/[^/]+\/kudos$/, 'Kudos'],
  [/^\/commitments\/[^/]+$/, 'Commitment'],
  [/^\/report$/, 'Report'],
  [/^\/messages$/, 'Messages'],
  [/^\/messages\/group$/, 'GroupChat'],
  [/^\/messages\/group\/info$/, 'GroupInfo'],
  [/^\/messages\/new$/, 'NewChat'],
  [/^\/messages\/search$/, 'Search'],
  [/^\/messages\/archived$/, 'Archived'],
  [/^\/messages\/broadcast$/, 'Broadcast'],
  [/^\/messages\/broadcasts$/, 'Sent broadcasts'],
  [/^\/messages\/broadcasts\/[^/]+$/, 'Sent broadcast'],
  [/^\/messages\/[^/]+\/contact$/, 'Contact'],
  [/^\/messages\/[^/]+\/media$/, 'Media'],
  [/^\/messages\/[^/]+\/wallpaper$/, 'Wallpaper'],
  [/^\/messages\/[^/]+$/, 'Chat'],
  [/^\/stories$/, 'Stories'],
  [/^\/stories\/view\/[^/]+$/, 'Story'],
  [/^\/connect(\/[^/]+)?$/, 'Qr'],
  [/^\/calls$/, 'CallLog'],
  [/^\/impact$/, 'Impact'],
  [/^\/members\/[^/]+$/, 'PosterProfile'],
  [/^\/promotions\/redeem$/, 'BizRedeem'],
  [/^\/promotions\/new$/, 'CreatePromo'],
  [/^\/promotions\/[^/]+\/edit$/, 'CreatePromo'],
  [/^\/promotions$/, 'Promotions'],
  [/^\/events\/new$/, 'CreateEvent'],
  [/^\/events\/[^/]+\/edit$/, 'CreateEvent'],
  [/^\/events$/, 'Events'],
  [/^\/profile$/, 'Profile'],
  [/^\/profile\/edit$/, 'EditProfile'],
  [/^\/profile\/trust$/, 'TrustHistory'],
  [/^\/profile\/warnings$/, 'Warnings'],
  [/^\/announcements$/, 'Announcements'],
  [/^\/profile\/notifications$/, 'NotificationSettings'],
  [/^\/admin$/, 'AdminDashboard'],
  [/^\/admin\/members$/, 'AdminUsers'],
  [/^\/admin\/members\/[^/]+$/, 'AdminUserDetail'],
  [/^\/admin\/reports$/, 'AdminReports'],
  [/^\/admin\/reports\/[^/]+\/mediation$/, 'Mediation'],
  [/^\/admin\/businesses$/, 'AdminBusiness'],
  [/^\/admin\/organizations$/, 'AdminOrgs'],
  [/^\/admin\/events$/, 'AdminEvents'],
  [/^\/admin\/announcements$/, 'AdminNotif'],
  [/^\/admin\/stats(\/[^/]+)?$/, 'AdminStats'],
];

export function screenNameFor(pathname: string): string | null {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return ROUTES.find(([pattern]) => pattern.test(path))?.[1] ?? null;
}
